<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="roles"
      single-select
      height="200px"
      show-select
      sort-by="description"
      dense
      disable-pagination
      item-key="id"
      hide-default-footer
      class="elevation-1"
      v-model="selectedRole"
      v-on:item-selected="roleItemSelected"
    >
      <template v-slot:top>
        <v-toolbar flat dense>
          <v-toolbar-title>Ruoli</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="am-2" v-bind="attrs" v-on="on">
                Nuovo Ruolo
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-card-text>
                      <v-container>
                        <v-text-field
                          label="Descrizione"
                          v-model="editedRole.description"
                        ></v-text-field>
                      </v-container>
                    </v-card-text>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" text @click="save"> Save </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="600px">
            <v-card>
              <v-card-title class="headline"
                >Are you sure you want to delete this role?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
    <!-- PERMESSI -->

    <v-data-table
      :headers="headerPermesso"
      :items="usersPermissions"
      show-select
      disable-pagination
      hide-default-footer
      height="300px"
      dense
      sort-by="permesso.descrizione"
      v-on:toggle-select-all="permissionSelectAll"
      v-on:item-selected="permissionItemSelected"
      value="usersPermissions"
      v-model="selectedPermissions"
      item-key="idPermesso"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat dense>
          <v-toolbar-title>Permessi</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
    </v-data-table>

    <!-- <v-col cols="6">
        <v-btn
          large
          color="error"
          style="width: 100%" 
          :to="{ name: 'dashboard' }"
        >
          Indietro
        </v-btn>
      </v-col> -->

    <v-card-actions class="align-right">
      <v-col class="text-right">
        <v-btn class="am-2" color="primary" @click="submitPermissions">
          Assegna Permessi
          <template v-slot:loader>
            <span>Loading...</span>
          </template>
        </v-btn>
      </v-col>
    </v-card-actions>
    <v-snackbar v-model="ShowSnackbar" :timeout="5000">
      {{ error }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="error = ''">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<style lang="scss">
.Card {
  padding: 30px !important;
}
</style>
<script>
import EasyPlanClient from "../../utils/EasyPlanClient";
export default {
  data: () => ({
    dialog: false,
    error: "",
    dialogDelete: false,
    headers: [
      { text: "Descrizione", value: "description" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    headerPermesso: [{ text: "Permesso", value: "permesso.descrizione" }],
    roles: [],
    selectedRole: "",
    selectedPermissions: [],
    permissions: [], //contiene tutti i permessi (necessario per inserimento)
    usersPermissions: [], // contiene i permessi relativi al ruolo (quindi con il flag abilitato/non abilitato)
    Permesso: "",
    loader: "",
    editedIndex: -1,
    editedRole: {
      description: "",
    },
    defaultItem: {
      description: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Ruolo" : "Edit Ruolo";
    },

    ShowSnackbar: {
      get() {
        if (this.error != undefined) return this.error.length > 0;
        else return false;
      },
      set(value) {
        if (!value) this.error = "";
      },
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();

    if (
      localStorage.userToken == undefined ||
      localStorage.userToken == "null"
    ) {
      console.debug("logging off");
      localStorage.userToken = null;

      this.$router.push({
        name: "login",
        params: { companyAlias: this.$route.params.companyAlias },
      });
    }
  },

  methods: {
    async submitPermissions() {
      this.loader = "loading";
      for (var i = 0; i < this.roles.length; i++) {
        try {
          let res = await EasyPlanClient.Role.Update(
            this.$route.params.companyAlias,
            this.roles[i]
          );
          console.debug("risposta update roles:");
          console.debug(res);
          this.permissions = res.data.data;
        } catch (error) {
          if (error.response != undefined)
            this.error = EasyPlanClient.GetErrorDescription(
              error.response.data.errorCode
            );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        }
      }
      this.$router.push({
        name: "login",
        params: { companyAlias: this.$route.params.companyAlias },
      });
    },
    initRolesPermissions() {
      //allineo permessi (tutti i permessi possibili) con i permessiruolo (userpermissions)
      //perchè un ruolo potrebbe non avere tutte le associazioni (tabella M:M) nel caso si introduca un permesso dopo la creazione del ruolo
      //poi aggiungo nel permessoruolo il riferimento del permesso perchè mi serve il campo Descrizione da mostrare

      for (var ir = 0; ir < this.roles.length; ir++) {
        let r = this.roles[ir];
        for (var ip = 0; ip < this.permissions.length; ip++) {
          let p = this.permissions[ip];
          let userPermission = r.permessi.find(
            (pu) => pu.idPermesso == p.idPermesso
          );

          console.debug("permessi:");
          console.debug(userPermission);
          if (userPermission == undefined) {
            userPermission = {
              idPermesso: p.idPermesso,
              abilitato: false,
              idRuolo: r.id,
            };
            r.permessi.push(userPermission);
          }
          userPermission.permesso = p;
        }
      }
    },
    roleItemSelected(event) {
      console.debug("item selected:" + event.value);
      console.debug(event.item);
      if (event.value) {
        this.usersPermissions = event.item.permessi;
        this.selectedPermissions = this.usersPermissions.filter(
          (up) => up.abilitato
        );
      } else this.usersPermissions = [];
    },
    permissionSelectAll(param) {
      let items = param.items;
      let value = param.value;
      console.debug(items);
      console.debug(this.selectedPermissions);
      for (var i = 0; i < items.length; i++) {
        let item = items[i];
        item.abilitato = value;
      }
      this.selectedRole.permessi = this.selectedPermissions;
    },
    permissionItemSelected(event) {
      console.debug(event);
      event.item.abilitato = event.value;
      this.selectedRole.permessi = this.selectedPermissions;
      console.debug(this.selectedPermissions);
    },
    initiRoles() {
      EasyPlanClient.Role.GetAll(this.$route.params.companyAlias)
        .then((res) => {
          console.debug("risposta get all roles:");
          console.debug(res);
          this.roles = res.data.data;
        })
        .catch((error) => {
          if (error.response != undefined)
            this.error = EasyPlanClient.GetErrorDescription(
              error.response.data.errorCode
            );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        })
        .finally(() => {
          this.initPermissions();
        });
    },

    insertRole(role) {
      console.debug("insert");
      EasyPlanClient.Role.Insert(
        this.$route.params.companyAlias,
        role.description
      )
        .then((res) => {
          console.debug("risposta get all roles:");
          console.debug(res);
          res.data.data.permessi = [];

          this.roles.push(res.data.data);
          this.initRolesPermissions();
        })
        .catch((error) => {
          if (error.response != undefined)
            this.error = EasyPlanClient.GetErrorDescription(
              error.response.data.errorCode
            );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
    initPermissions() {
      EasyPlanClient.Permissions.GetAll()
        .then((res) => {
          console.debug("risposta get all roles:");
          console.debug(res);
          this.permissions = res.data.data;
        })
        .catch((error) => {
          if (error.response != undefined)
            this.error = EasyPlanClient.GetErrorDescription(
              error.response.data.errorCode
            );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        })
        .finally(() => {
          this.initRolesPermissions();
        });
    },
    initialize() {
      if (
        localStorage.userToken == undefined ||
        localStorage.userToken == "null"
      ) {
        console.debug("logging off");
        localStorage.userToken = null;

        this.$router.push({
          name: "login",
          params: { companyAlias: this.$route.params.companyAlias },
        });
      }
      this.initiRoles();
    },

    editItem(item) {
      this.editedIndex = this.roles.indexOf(item);
      this.editedRole = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.roles.indexOf(item);
      this.editedRole = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.roles.splice(this.editedIndex, 1);
      this.editedRole.isRemoved = true;
      this.editRole(this.editedRole, this.editedIndex);
      this.closeDelete();
      EasyPlanClient.Role.Delete(
        this.$route.params.companyAlies,
        this.editedIndex
      )
        .then((res) => {
          alert("Role was deleted");
        })
        .catch((error) => {
          console.error(error);
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedRole = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedRole = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    editRole(role, editedIndex) {
      console.debug("edit");
      EasyPlanClient.Role.Update(this.$route.params.companyAlias, role)
        .then((res) => {
          console.debug("risposta get all roles:");
          console.debug(res);
          res.data.data.permessi = this.roles[editedIndex].permessi; //mantengo permessi che aveva editato l'utente
          Object.assign(this.roles[editedIndex], res.data.data);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    save() {
      if (this.editedIndex > -1) {
        this.editRole(this.editedRole, this.editedIndex);
      } else {
        this.insertRole(this.editedRole);
      }
      this.close();
    },
  },
};
</script>
